export { InlineCopyComponent } from './inline-copy.component';
export { InlineCopyModule } from './inline-copy.module';
